import React from 'react';
import BaseSimplePage from "../BaseSimplePage/BaseSimplePage";
import GenresItemForm from "./GenresItemForm";

const GenresPage = ({isAddSubMode}) => {

    return (
        <BaseSimplePage
            isAddSubMode={isAddSubMode}
            modeApiName1="genre"
            modeApiName2="genres"
            ItemFormComponent={GenresItemForm}
        />
    );
};

export default GenresPage;